export const APP_VERSION = process.env.REACT_APP_APP_VERSION as string;
export const AUTH_REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI as string;
export const OLD_APP_URL = process.env.REACT_APP_OLD_APP_URL as string;
